import React from 'react';
import { Briefcase, Building2, Landmark } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  briefcase: Briefcase,
  building2: Building2,
  landmark: Landmark,
};

const AudienceCard = ({ audience }) => {
  const IconComponent = iconMap[audience.icon] || Briefcase;

  return (
    <div className="group flex flex-col p-6 md:p-8 border border-[#3f4816]/50 bg-transparent transition-colors duration-150 hover:bg-[#3f4816]/20">
      {/* Icon */}
      <div className="w-14 h-14 rounded-full border border-[#d9fb06]/30 flex items-center justify-center mb-5 group-hover:border-[#d9fb06]/60 transition-colors">
        <IconComponent className="w-6 h-6 text-[#d9fb06]" />
      </div>

      {/* Title */}
      <h3 className="font-bold text-[#d9fb06] text-lg md:text-xl mb-3">
        {audience.title}
      </h3>

      {/* Description */}
      <p className="text-[#888680] text-sm md:text-base leading-relaxed">
        {audience.description}
      </p>
    </div>
  );
};

const AudienceSection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-[#302f2c] py-20 md:py-28">
      <div className="max-w-[87.5rem] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-12">
          <h2 className="font-black text-[#d9fb06] text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.85]">
            {t.audience.title}
          </h2>
        </div>

        {/* Audience Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.audience.items.map((audience) => (
            <AudienceCard key={audience.id} audience={audience} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
